<template>
	<el-card class="export-user-wrap">
		<!-- 顶部按钮区域 -->
      	<el-row class="common-con-btns mb10">
        	<el-button size="small" type="primary" class="fresh-btn" @click="fresh">刷新</el-button>
      	</el-row>
        <!-- 表格区域 -->
        <el-table
			class="page-wrap"
			:data="dataList"
			ref="listTable"
			header-row-class-name="table-black-header"
			style="width: 100%">
			<el-table-column label="名称" prop="file_name">
			</el-table-column>
			<el-table-column label="数量（个）" prop="num">
			</el-table-column>
			<el-table-column label="生成时间" prop="created_at">
			</el-table-column>
			<el-table-column label="状态">
				<template slot-scope="scope">
					<span v-if="scope.row.state == 1">导出中</span>
					<span v-if="scope.row.state == 2">导出完成</span>
					<span v-if="scope.row.state == 3">导出失败</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" v-if="scope.row.state == 2" @click="confirmExport(scope.row.oss_source)">导出</el-button>
					<el-button type="text" v-else>-</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--页码信息-->
		<div class="ftc mt10">
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:total="page.total"
				:page-size="page.pageSize"
				@current-change="currentPageChange">
			</el-pagination>
		</div>
	</el-card>
</template>

<script>
	import { exportApi } from '@/api/export'
	import {EpetJs} from "../../utils/epetsdk";
	export default{
		data(){
			return{
				selects:{
					ac_id:'',
					mobile:''
				},
				page:{
					currentPage:1,
					pageSize:50,
					total:0
				},
				dataList:[]
			}
		},
		mounted(){
			this.getExportList()
		},
		methods:{
			//获取导出用户列表
			getExportList(){
				const pam = {
					page:this.page.currentPage,
					per_page:this.page.pageSize,
					ac_id:this.selects.ac_id,
					mobile:this.selects.mobile
				}
				this.$EpetJs.Common.ajax('get',exportApi.getExportListUrl,pam,{
					needLoading:true
				}).then(res=>{
					this.dataList = res.data.data
					if (res.data.meta && res.data.meta.pagination) {
			            this.page.total = res.data.meta.pagination.total
			            this.page.currentPage = res.data.meta.pagination.current_page
			        }
				})
			},
			//确认导出
			confirmExport(url){
				url = url.replace(/^http:/,  EpetJs.Const.PROTOCOL)
				const pam = {
					domain:url
				}
				this.$EpetJs.Common.get(exportApi.getOssUrl,pam).then(res=>{
					if(res){
						const url = res.data.data.url
                        window.location.href = url
					}
				})
			},
			//刷新
			fresh(){
				this.getExportList()
			},
			//翻页
			currentPageChange(val){
				this.page.currentPage = val
				this.getExportList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.export-user-wrap{
		min-height: calc(100vh - 60px);
	}
</style>
